import styled from 'styled-components';

// Components
import { Typography } from '../../../../display/Typography';

// Reusa el patrón visual del control de ordenación del mismo modal
// (`SortControl`/`SortOptionsRow`/`SortOptionButton`) en vez de inventar otro:
// misma columna centrada, mismos botones planos con `aria-pressed`.
import { SortControl, SortOptionsRow, SortOptionButton } from '../styles';

export const OptionsControl = styled(SortControl)`
  gap: 1.2rem;
  padding-bottom: 1.6rem;
  width: 100%;
`;

export const PresetsRow = styled(SortOptionsRow)`
  gap: 1.6rem;
`;

/**
 * Botón de preset: el activo se marca con fondo y borde de acento (el
 * `aria-pressed` es además lo que consultan los tests).
 */
export const PresetButton = styled(SortOptionButton)<{ $active: boolean }>`
  padding: 0.6rem 1.8rem;
  border-radius: 2rem;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.garnet : theme.colors.greySilver};
  background-color: ${({ theme, $active }) =>
    $active ? theme.colors.garnetClear : 'transparent'};
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  align-self: stretch;
  padding: 0 2rem;
`;

export const OptionRow = styled.label`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
`;

/** Sub-niveles del bloque de actuaciones: sangrados bajo su casilla. */
export const ChildrenModes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding-left: 3.2rem;
`;

export const ModeRow = styled.label<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.9rem;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
`;

export const OptionText = styled(Typography)`
  text-align: left;
`;
